import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../utils';
import RadioFocused from '../assets/images/radio-button-focused.svg';
import RadioNotSelected from '../assets/images/radio-button-not-selected.svg';
import RadioSelected from '../assets/images/radio-button-selected.svg';

function getBackgroundImage(props) {
  return props.checked ? RadioSelected : RadioNotSelected;
}

function getBackgroundImageFocused(props) {
  return props.checked ? RadioSelected : RadioFocused;
}

const RadioContainer = styled.div`
  align-self: flex-start;
  background-color: transparent;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  margin: 13px 0;
  padding: 0;
`;

const Label = styled.p`
  color: ${colors.g05};
  font-size: ${props => props.fontSize}px;
  font-weight: normal;
  justify-content: left;
  line-height: 1;
  margin: 0 12px;
  width: auto;
`;

const CheckComponent = styled.input`
  display: none;
`;

const CheckDivComponent = styled.div`
  align-items: center;
  display: flex;
  height: 12px;
  justify-content: center;
  position: relative;
  transition: all 150ms;
  width: 12px;

  &:after {
    align-items: center;
    background-image: url(${getBackgroundImage});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100%;
    content: '';
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
  }

  &:focused,
  &:hover {
    &:after {
      background-image: src(${getBackgroundImageFocused});
    }
  }
`;

const Radio = props => {
  const { label, checked, onChange, onToggle } = props;

  return (
    <RadioContainer {...props}>
      <CheckDivComponent {...props} checked={checked} onClick={() => onToggle(!checked)}>
        <CheckComponent type="radio" checked={checked} onChange={onChange} />
      </CheckDivComponent>

      <Label onClick={() => onToggle(!checked)}>{label}</Label>
    </RadioContainer>
  );
};

Radio.defaultProps = {
  checked: false,
  fontSize: 16,
  onChange: () => {},
  onToggle: () => {},
  label: ''
};

Radio.propTypes = {
  checked: PropTypes.bool,
  fontSize: PropTypes.number,
  onChange: PropTypes.func,
  onToggle: PropTypes.func,
  label: PropTypes.string
};

export { Radio };
